import React from 'react';
import { ptBR } from 'date-fns/locale';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { createMuiTheme } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import EventIcon from '@material-ui/icons/Event';

import * as S from './styles';

const defaultMaterialTheme = createMuiTheme({
  palette: {
    text: {
      primary: '#5e6876',
    },
    primary: {
      main: '#F38D45',
    },
  },
});

const DatePickerComponent = ({ value, onChange }) => {
  return (
    <S.FilterInputWrapper>
      <span>Filtrar:</span>
      <MuiThemeProvider theme={defaultMaterialTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
          <DatePicker
            variant="inline"
            openTo="year"
            views={['year', 'month']}
            format="MMMM 'de' yyyy"
            value={value}
            onChange={onChange}
          />
          <EventIcon className="icon" />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </S.FilterInputWrapper>
  );
};

export default DatePickerComponent;
